// extracted by mini-css-extract-plugin
export var externalLink = "_d4-0";
export var internalLinkLabel = "_d4-1";